<template>
<div>
    <b-navbar toggleable="md" class="navbar-expand-md navbar-light bg-light">
      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
      <b-navbar-brand href="#" class="navbar-brand pr-2 pl-2">
        <router-link :to="{name:'home'}">
          <img :src="$store.state.globalTheme.LOGO" width="120" alt="" class="d-inline-block align-middle">
        </router-link>
      </b-navbar-brand>
      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav id="nav" class="navbar-nav mr-auto mt-2 mt-lg-0">
          <b-nav-item>
            <router-link :to="{name:'home'}" class="nav-link">Home</router-link>
          </b-nav-item>
          <b-nav-item>
            <router-link :to="{name:'gallery'}" class="nav-link">{{ $store.state.globalTheme.GALLERY_ALIAS }}</router-link>
          </b-nav-item>
          <b-nav-item>
            <router-link :to="{name:'about'}" class="nav-link">About</router-link>
          </b-nav-item>
          <b-nav-item>
            <router-link :to="{name:'areas'}" class="nav-link">Browse by {{ $store.state.globalTheme.AREA_ALIAS }}</router-link>
          </b-nav-item>
        </b-navbar-nav>
      </b-collapse>
      <b-navbar-nav class="social-part">
        <b-nav-item v-if="$store.state.globalTheme.FACEBOOK" class="pt-2 d-xl-block d-lg-block d-md-block d-none">
          <i class="fab" aria-hidden="true">
            <font-awesome-icon @click="socialNav($store.state.globalTheme.FACEBOOK)" :icon="[ 'fab', 'facebook-f']" /></i>
        </b-nav-item>
        <b-nav-item v-if="$store.state.globalTheme.TWITTER" class="pt-2 d-xl-block d-lg-block d-md-block d-none">
          <i class="fab" aria-hidden="true">
            <font-awesome-icon @click="socialNav($store.state.globalTheme.TWITTER)" :icon="[ 'fab', 'twitter']" /></i></b-nav-item>
        <b-nav-item v-if="$store.state.globalTheme.LINKEDIN" class="pt-2 d-xl-block d-lg-block d-md-block d-none">
          <i class="fab" aria-hidden="true">
            <font-awesome-icon @click="socialNav($store.state.globalTheme.LINKEDIN)" :icon="[ 'fab', 'linkedin']" /></i>
        </b-nav-item>
        <b-nav-item v-if="$store.state.globalTheme.INSTAGRAM" class="pt-2 d-xl-block d-lg-block d-md-block d-none">
          <i class="fab" aria-hidden="true">
            <font-awesome-icon @click="socialNav($store.state.globalTheme.INSTAGRAM)" :icon="[ 'fab', 'instagram']" /></i>
        </b-nav-item>
        <b-nav-item v-if="!loggedIn">
          <router-link :to="{name:'login'}" class="nav-link">Login</router-link>
        </b-nav-item>
        <b-nav-item-dropdown v-if="loggedIn" id="nav7_ddown" right>
          <template slot="button-content">
            <b-avatar :src="profile_image" ></b-avatar>

          </template>
          <b-dropdown-item :to="{name: 'profile'}">My Profile</b-dropdown-item>
          <b-dropdown-item :to="{name: 'watched'}">Watch List</b-dropdown-item>
          <b-dropdown-divider></b-dropdown-divider>
          <b-dropdown-item @click="logOut">Logout</b-dropdown-item>
        </b-nav-item-dropdown>
      </b-navbar-nav>
    </b-navbar>
    <b-alert :show="dismissCountDown" dismissible :variant="alert_variant" @dismissed="dismissCountDown=0" @dismiss-count-down="countDownChanged">
      <p>{{ alert_wording}}</p>
      <b-progress :variant="alert_variant" :max="dismissSecs" :value="dismissCountDown" height="4px"></b-progress>
    </b-alert>
    <router-view :key="$route.path"></router-view>

  <b-container>
      <b-row class="my-1">
        <b-col cols="12">
          <hr>
        </b-col>
        <b-col cols="12" xl="8" lg="8" md="8" class="text-center text-xl-left text-lg-left text-md-left align-middle my-2">
          <h6 class="small">&copy; 2020 CloserStill Media.&emsp;<router-link :to="{name:'terms'}">Terms &amp; Conditions</router-link>&emsp;<router-link :to="{name:'privacy'}">Privacy Policy</router-link></h6>
        </b-col>
        <b-col cols="12" xl="4" lg="4" md="4" class="text-center text-xl-right text-lg-right text-md-right align-middle my-2">
          <p class="small">Follow us on:&emsp;<i class="fab" aria-hidden="true">
              <a style="color: black" :href="$store.state.globalTheme.FACEBOOK" target="_blank"><font-awesome-icon :icon="[ 'fab', 'facebook-f']" /></a></i>&emsp;
              <i class="fab" aria-hidden="true">
              <a style="color: black" :href="$store.state.globalTheme.TWITTER" target="_blank"><font-awesome-icon :icon="[ 'fab', 'twitter']" /></a></i>&emsp;
              <i class="fab" aria-hidden="true">
              <a style="color: black" :href="$store.state.globalTheme.INSTAGRAM" target="_blank"><font-awesome-icon :icon="[ 'fab', 'instagram']" /></a></i></p>
        </b-col>
      </b-row>
    </b-container>
</div>



</template>

<script>
import { getAPI } from '../store/axios-base'

    export default {
        name: "Header.vue",


        data() {
      return {
        dismissSecs: 2,
        dismissCountDown: 0,
        showDismissibleAlert: false,
        profile_image: '',
        alert_wording:'',
        alert_variant:'warning',
      }}
      ,

        components: {
        },
        computed: {
            loggedIn: function () {
                return this.$store.getters.loggedIn
            }
        },
        mounted() {
            this.FetchUser()
        },
        watch: {
        loggedIn (newvar, oldvar) {
          this.FetchUser();
          }
          }
        ,
        methods: {
          socialNav(link){
              window.open(link);
          },

        logOut() {
            this.showAlert('logout')
            this.$store.dispatch('logoutUser')
            this.$router.push('/')
        },
        FetchUser:function(){
            if(this.$store.getters.loggedIn) {
                var headers = { Authorization: `Bearer ${this.$store.state.accessToken}` }

            getAPI.get("/api/account/user/",{ headers: headers }).then(response => {
              this.profile_image = response.data.profile_image;
              if(response.data.profile_image == '' || response.data.profile_image === null){
                  this.profile_image = ''
              }
          })
            }}
          ,

        countDownChanged(dismissCountDown) {
        this.dismissCountDown = dismissCountDown
      },
      showAlert(name) {
        var alertData = this.$globalConstants.alerts[name]
        this.alert_wording = alertData.alert
        this.dismissCountDown = alertData.time
        this.alert_variant = alertData.variant
      }

    }}

</script>

<style scoped>


</style>



// WEBPACK FOOTER //
// src/components/Header.vue